import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { logout, resetAllState } from "../../../redux/Reducer/authSlice";
import { setSidebarVisible } from "../../../redux/Reducer/AdminAccount/AccountSlice";
import Button from "../../common/Button";
import { persistor } from "../../../redux/store";
import Logout from "../../common/icons/Logout";
import UserAccount from "../../common/icons/UserAccount";
import Inventory from "../../common/icons/Inventory";
import Dashbaord from "../../common/icons/Dashboard";
import ArrowBack from "../../common/icons/ArrowBack";
import CreateOrder from "../../common/icons/CreateOrder";

const AdminSidebar = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [selectedRoute, setSelectedRoute] = useState("");
  const [isConfirm, setIsConfirm] = useState(false);
  const adminDetails = useSelector((state) => state?.admin?.adminDetails);
  const { role, user } = useSelector((state) => state.auth);
  const isSidebarVisible = useSelector((state) => state.admin?.isSidebarVisible);

  // Auto-hide Logic
  useEffect(() => {
    let timeoutId;
    const resetTimer = () => {
      if (timeoutId) clearTimeout(timeoutId);
      // Wait 5 seconds of inactivity before hiding
      timeoutId = setTimeout(() => {
        const adminPaths = ["/inventory", "/stores", "/admin-profile", "/prescription-moderation"];
        if (adminPaths.includes(pathname)) {
          dispatch(setSidebarVisible(false));
        }
      }, 5000);
    };

    const adminPaths = ["/inventory", "/stores", "/admin-profile", "/prescription-moderation"];
    if (isSidebarVisible && adminPaths.includes(pathname)) {
      resetTimer();
      // Reset timer on any mouse movement or click within the sidebar
      const sidebarElement = document.getElementById("admin-sidebar");
      if (sidebarElement) {
        sidebarElement.addEventListener("mousemove", resetTimer);
        sidebarElement.addEventListener("click", resetTimer);
      }

      return () => {
        if (timeoutId) clearTimeout(timeoutId);
        if (sidebarElement) {
          sidebarElement.removeEventListener("mousemove", resetTimer);
          sidebarElement.removeEventListener("click", resetTimer);
        }
      };
    }
  }, [isSidebarVisible, pathname, dispatch]);

  useEffect(() => {
    if (!user?.token || role !== "admin") {
      dispatch(resetAllState());
      localStorage.clear();
      persistor.purge();
      window.location.href = process.env.REACT_APP_ADMIN_URL;

    }
  }, [dispatch, role, user?.token]);

  useEffect(() => {
    if (pathname) {
      setSelectedRoute(pathname);
    }
  }, [pathname]);

  const handleLogout = () => {

    if (isConfirm) {
      localStorage.clear();
      dispatch(logout());
      dispatch(resetAllState());
      persistor.purge();
      window.location.href = process.env.REACT_APP_ADMIN_URL;
      setIsConfirm(false);
    } else {
      setIsConfirm(true);
    }
  };

  return (
    <>
      {/* Mobile Backdrop */}
      <div 
        className={`fixed inset-0 bg-black/40 backdrop-blur-[2px] z-[998] transition-opacity duration-500 md:hidden ${isSidebarVisible ? "opacity-100" : "opacity-0 pointer-events-none"}`}
        onClick={() => dispatch(setSidebarVisible(false))}
      />
      <div
        id="admin-sidebar"
        className={`fixed left-0 top-0 h-[100vh] w-[80px] z-[999] flex flex-col justify-between transition-all duration-500 ease-in-out ${isSidebarVisible ? "translate-x-0" : "-translate-x-full"} ${isConfirm ? " bg-primary-700" : "bg-primary-600 shadow-2xl"}`}>
      <div className="bg-primary-300">
        <div className="py-[24px] justify-center">
          <div className="flex flex-col items-center justify-center h-[40px] gap-2">
            <img src="/logo.png" alt="hyperapt-logo" className="h-[40px]" />
            <img src="/logo.svg" alt="hyperapt" className="w-[70px] max-w-none mx-auto" />
          </div>
        </div>
        <div className="p-2 bg-primary-300">
          <h5 className="text-ellipsis block line-clamp-1 whitespace-nowrap tooltip-button text-primary-700 uppercase font-medium text-[12px]">
            {adminDetails?.username}
          </h5>
        </div>
      </div>
      <div className={`pb-3 ${isConfirm ? "h-[calc(100vh_-_254px)]" : "h-[calc(100vh_-_187px)]"}`}>
        {!isConfirm &&
          <ul>
            <li>
              <Link
                to={"/inventory"}
                className={`flex flex-col items-center text-[12px] text-primary-50 gap-2 px-3 py-2 min-h-[56px] w-full transition-all duration-300 ${selectedRoute === "/inventory"
                  ? "bg-primary-700 hover:text-primary-50/100"
                  : "hover:text-primary-50/30"
                  } font-medium`}
              >
                <Inventory />
                Inventory
              </Link>
            </li>
            {adminDetails?.role !== "manager" && (
              <>
                <li>
                  <Link
                    to={"/stores"}
                    className={`flex flex-col items-center text-[12px] text-primary-50 gap-2 px-3 py-2 min-h-[56px] w-full transition-all duration-300 ${selectedRoute === "/stores"
                      ? "bg-primary-700 hover:text-primary-50/100"
                      : "hover:text-primary-50/30"
                      } font-medium`}
                  >
                    <Dashbaord />
                    Orders
                  </Link>
                </li>
                <li>
                  <Link
                    to={"/admin-profile"}
                    className={`flex flex-col items-center text-[12px] text-primary-50 gap-2 px-3 py-2 min-h-[56px] w-full transition-all duration-300 ${selectedRoute === "/admin-profile"
                      ? "bg-primary-700 hover:text-primary-50/100"
                      : "hover:text-primary-50/30"
                      } font-medium`}
                  >
                    <UserAccount />
                    Accounts
                  </Link>
                </li>
                <li>
                  <Link
                    to={"/prescription-moderation"}
                    className={`flex flex-col items-center text-[12px] text-primary-50 gap-2 px-3 py-2 min-h-[56px] w-full transition-all duration-300 ${selectedRoute === "/prescription-moderation"
                      ? "bg-primary-700 hover:text-primary-50/100"
                      : "hover:text-primary-50/30"
                      } font-medium`}
                  >
                    <CreateOrder fill="#F8F6F6" />
                    Prescription
                  </Link>
                </li>
              </>
            )}
          </ul>
        }
      </div>
      <div>
        <ul>
          {isConfirm && (
            <li>
              <Button
                className={`flex flex-col items-center text-[12px] text-primary-50 gap-2 px-3 py-2 min-h-[56px] w-full transition-all duration-300 hover:text-primary-50/30  font-medium group`}
                onClick={() => setIsConfirm(false)}
              >
                <span className="transition-all duration-200 group-hover:opacity-20">
                  <ArrowBack fill="#fff" height={25} width={25} />
                </span>
                Back
              </Button>
            </li>
          )}
          <li>
            <Button
              onClick={handleLogout}
              to={"/"}
              className="flex flex-col items-center text-[12px] text-primary-50 gap-2 px-3 py-2 min-h-[56px] w-full transition-all duration-300 hover:text-primary-50/30 group"
            >
              <span className={`transition-all duration-200 ${isConfirm ? "group-hover:opacity-20" : "group-hover:opacity-30"}`}>
                <Logout height={23} width={23} />
              </span>
              {isConfirm ? "Logout" : "Logout"}
            </Button>
          </li>
        </ul>
      </div>
    </div>
    </>
  );
};

export default AdminSidebar;
